// ZOK-2359: email domains the account owner blocks from creating accounts on public
// pages (Domain settings > Blocked sign-up domains). These checks only warn early: the
// API enforces the same rule (apprendo-api lib/blockedSignupDomains.js) - keep them in step.

export const BLOCKED_SIGNUP_CODE = 'SIGNUP_DOMAIN_BLOCKED';

// Where people from a blocked domain sign in instead (Azure buttons for YG).
export const EMPLOYEE_PORTAL_URL = '/aprendo/login';

export const parseDomains = (value) => {
    if (!value) { return []; }
    const list = Array.isArray(value) ? value : String(value).split(/[\s,;]+/);
    const domains = list
        .map(domain => String(domain).trim().toLowerCase().replace(/^@+/, '').replace(/\.+$/, ''))
        .filter(Boolean);
    return Array.from(new Set(domains));
};

// A domain also blocks its subdomains: yukon.ca blocks mail.yukon.ca.
export const isEmailBlocked = (email, domains) => {
    const list = parseDomains(domains);
    if (!email || !list.length) { return false; }
    const address = String(email).trim().toLowerCase();
    const at = address.lastIndexOf('@');
    if (at < 0) { return false; }
    const host = address.slice(at + 1).replace(/\.+$/, '');
    if (!host) { return false; }
    return list.some(domain => host === domain || host.endsWith('.' + domain));
};

export const isBlockedSignupResponse = (data) => !!data && data.code === BLOCKED_SIGNUP_CODE;
